import styles from "./styles.module.scss";
import beforeWalky from "./img/before-walky.png";
import afterWalky from "./img/after-walky.png";
import beforeEasyfit from "./img/before.png";
import afterEasyfit from "./img/after.png";

const TRANSFORM_CONTENT = {
  walky: {
    title:
      "Your comprehensive walking plan to help <br /> you feel and look your best",
    description:
      "Take control of your health goals - your all-in-one walking companion <br /> to help you stay on track and see lasting results.",
    boxText: 'Walking level',
    before: beforeWalky,
    after: afterWalky,
    style: "walky",
  },
  easyfit: {
    title: "Get a complex solution <br /> to your weight loss problem",
    description:
      "Take control of your weight goals — get all-in-one solution to calculate and&nbsp;execute your plan to lose weight and see visible results fast.",
    boxText: 'Exercise level',
    before: beforeEasyfit,
    after: afterEasyfit,
    style: "easyfit",
  },
};

export const Transform = ({ isWalky }) => {
  const variant = isWalky ? TRANSFORM_CONTENT.walky : TRANSFORM_CONTENT.easyfit;

  return (
    <section className={`${styles.transform} ${styles[variant.style]}`}>
      <div className={styles.transformContent}>
        <div className={styles.title}>
          <h2 dangerouslySetInnerHTML={{ __html: variant.title }} />
          <p dangerouslySetInnerHTML={{ __html: variant.description }} />
        </div>

        <div className={styles.nowAfter}>
          <div className={styles.header}>
            <div className={styles.headerItem}>Now</div>
            <div className={styles.headerDivider}></div>
            <div className={styles.headerItem}>
              <span>After the program</span>
            </div>
          </div>

          <div className={styles.body}>
            <div className={styles.imageWrapper}>
              <div className={styles.beforeImage}>
                <img
                  src={variant.before}
                  alt="Before"
                  className={styles.comparisonImage}
                />
                <div className={styles.blur}></div>
              </div>
              <div className={styles.afterImage}>
                <img
                  src={variant.after}
                  alt="After"
                  className={styles.comparisonImage}
                />
                <div className={styles.blur}></div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.cards}>
          <div className={styles.cardsWrapper}>
            <div className={styles.metric}>
              <div className={styles.metricContent}>
                <p className={styles.metricTitle}>Body fat</p>
                <p className={styles.value}>Overweight</p>
              </div>
            </div>
            <div className={styles.metric}>
              <div className={styles.metricContent}>
                <p className={styles.metricTitle}>{variant.boxText}</p>
                <p className={styles.value}>Beginner</p>
              </div>
              <div className={styles.levelIndicators}>
                {Array.from({ length: 3 }, (_, index) => (
                  <div
                    key={index}
                    className={`${styles.indicator} ${
                      index < 1 ? styles.filled : ""
                    }`}
                  ></div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.cardsWrapper}>
            <div className={styles.metric}>
              <div>
                <p className={styles.metricTitle}>Body fat</p>
                <p className={styles.value}>Normal</p>
              </div>
            </div>
            <div className={styles.metric}>
              <div>
                <p className={styles.metricTitle}>{variant.boxText}</p>
                <p className={styles.value}>Intermediate</p>
              </div>
              <div className={styles.levelIndicators}>
                {Array.from({ length: 3 }, (_, index) => (
                  <div
                    key={index}
                    className={`${styles.indicator} ${
                      index < 2 ? styles.filled : ""
                    }`}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
